module.exports = __webpack_public_path__ + "img/CNN-COVER.f961c923.png";